import { NgFor, NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ICustomError } from '../../../../Utils/_models/network-response';

@Component({
  selector: 'app-test-errors',
  standalone: true,
  imports: [NgIf, NgFor],
  templateUrl: './test-errors.component.html',
  styleUrl: './test-errors.component.css'
})
export class TestErrorsComponent {
  
  private baseURL: string = environment.baseUrl;
  private endpoint: string = "/buggy";
  private _http = inject(HttpClient);
  public validationErrors: string[] = [];


  get400Error() {
    this._http.get(`${this.baseURL}/${this.endpoint}/bad-request`).subscribe({
      next: response => console.log(response),
      error: (error: ICustomError) => console.log(error)
    })
  }

  get401Error() {
    this._http.get(`${this.baseURL}/${this.endpoint}/auth`).subscribe({
      next: response => console.log(response),
      error: (error: ICustomError) => console.log(error)
    })
  }


  get404Error() {
    this._http.get(`${this.baseURL}/${this.endpoint}/not-found`).subscribe({
      next: response => console.log(response),
      error: (error: ICustomError) => console.log(error)
    })
  }


  get500Error() {
    this._http.get(`${this.baseURL}/${this.endpoint}/server-error`).subscribe({
      next: response => console.log(response),
      error: (error: ICustomError) => console.log(error)
    })
  }


  get400ValidationError() {
    this._http.post(`${this.baseURL}/auth/register`, {}).subscribe({
      next: response => console.log(response),
      error: error => {
        console.log(error);
        this.validationErrors = error;
      }
    })
  }
}
